export type Theme = "auto" | "dark" | "light";

const DATA_BS_THEME = "data-bs-theme";

// theming utilities
const getStoredTheme = (): string | null => localStorage.getItem(DATA_BS_THEME);

const getPreferredTheme = (): Theme => {
    const storedTheme = getStoredTheme();

    if (storedTheme) {
        if (storedTheme === "auto") {
            return "auto";
        }

        if (storedTheme === "dark") {
            return "dark";
        }

        return "light";
    }

    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
};

const setAttribute = (theme: Theme) => {
    document.documentElement.setAttribute(DATA_BS_THEME, theme);
};
// set the theme; to be used by the theme selection component
export const setTheme = (theme: Theme) => {
    if (theme === "auto" && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        // document.documentElement.setAttribute(DATA_BS_THEME, ThemeType.Dark);
        setAttribute("dark");
    } else {
        setAttribute(theme);
    }

    // save it to local storage if necessary
    if (getStoredTheme() !== theme) {
        localStorage.setItem(DATA_BS_THEME, theme);
    }
}

// get the user theme setting (light, dark, auto)
export const getTheme = (): Theme => {
    return getPreferredTheme();
};

// get the actual theme in use (light, dark)
export const getEffectiveTheme = (): Theme => {
    const theme = getPreferredTheme();

    if (theme === "auto") {
        if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
            return "dark";
        }

        return "light";
    }

    return theme;
};

// store the theme to a cookie
export const initializeTheme = () => {
    const theme = getPreferredTheme();
    setTheme(theme);
};

// string utils
export const getToggleThemeId = (): string => {
    const theme = getEffectiveTheme();
    // get the opposite theme
    return (theme === "light") ? "dark" : "light";
};

export const getActiveThemeId = (): string => {
    const theme = getPreferredTheme();
    return theme.toString();
};